var React = require('react');

function IconBasket (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M256 82.9V228h512V82.9c0-11-9-20-20-20H276c-11 0-20 8.9-20 20zm448.1 108.9h-384v-62.9h384v62.9z","key":0}),React.createElement("path",{"d":"M950.2 282h-876c-5.5 0-10-4.5-10-10v-70.2c0-5.5 4.5-10 10-10h876c5.5 0 10 4.5 10 10V272c0 5.5-4.5 10-10 10z","key":1}),React.createElement("path",{"d":"M800.2 256v605.1H225V256h-97v682.6c0 11 9 20 20 20h728.1c11 0 20-9 20-20V256h-95.9z","key":2}),React.createElement("path",{"d":"M447.8 767.8h-79.6c-4.4 0-8-3.6-8-8v-368c0-4.4 3.6-8 8-8h79.6c4.4 0 8 3.6 8 8v368c0 4.4-3.6 8-8 8zM655.8 767.8h-79.6c-4.4 0-8-3.6-8-8v-368c0-4.4 3.6-8 8-8h79.6c4.4 0 8 3.6 8 8v368c0 4.4-3.6 8-8 8z","key":3})]);
}

IconBasket.displayName = "IconBasket";

IconBasket.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconBasket;

IconBasket.default = IconBasket;
